/*
 * Listener management for flux implementation
 * Extracted to break circular dependency between index.js and wrapper.jsx
 */

const _listeners = {};
let _lastKey = 0;

export function addListener(interests, handler) {
  _listeners[_lastKey] = { interests, handler };
  _lastKey += 1;
  return _lastKey - 1;
}

export function removeListener(index) {
  delete _listeners[index];
}

export function getListeners() {
  return _listeners;
}
